// ============================================================================
// Imports: CSS
// ============================================================================
import '../stylesheets/styles.scss';

// ============================================================================
// Imports: Global & Dependencies
// ============================================================================
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks.js';
import 'lazysizes/plugins/attrchange/ls.attrchange.js';
import 'lazysizes/plugins/blur-up/ls.blur-up.js';
import 'foundation-sites/js/foundation.core.js';
import Foundation from 'foundation-sites/js/foundation.js';
import Reveal from 'foundation-sites/js/foundation.reveal';
import 'foundation-sites/js/foundation.util.keyboard.js';
import 'foundation-sites/js/foundation.util.triggers.js';
import 'foundation-sites/js/foundation.util.mediaQuery.js';
import 'foundation-sites/js/foundation.util.motion.js';
// var Flickity = require('flickity');
// @TODO maybe not using flickity
// require('flickity/flickity-imagesloaded');
// require('flickity-fullscreen');
// require('flickity-bg-lazyload');
import mediumZoom from 'medium-zoom';

// ============================================================================
// Imports: Custom
// ============================================================================
// require('./modules/module-functions.js');
require('./modules/module-masonry.js');

// ============================================================================
// Variables
// ============================================================================
var body = document.body;

var showtime = function() {
  body.classList.add('showtime');
}

// ============================================================================
// Init: Document Ready
// ============================================================================
$(document).ready(function() {
  showtime();

  //add simple support for background images:
  document.addEventListener('lazybeforeunveil', function(e){
      var bg = e.target.getAttribute('data-bg');
      if(bg){
          e.target.style.backgroundImage = 'url(' + bg + ')';
      }
  });

  // var elem = document.querySelector('.main-carousel');
  // var flkty = new Flickity(elem, {
  //   // options
  //   adaptiveHeight: true,
  //   cellAlign: 'center',
  //   contain: true,
  //   bgLazyLoad: true,
  //   bgLazyLoad: 2
  // });

  // startSlideshowButton.addEventListener('click', () => {
  //   flkty.viewFullscreen();
  // });

  mediumZoom('[data-zoomable]', {
    background: '#EEE8DA',
    scrollOffset: 0,
  })

  Masonry();
});
